import React,{ useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderBack from '././HeaderBack';
import MessageBar from './MessageBar';

export default function MessageFeed({titleHead}){
	
	let navigate = useNavigate();
	
	useEffect(() => {
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(authToken){
			navigate('/messageuser')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, [])
	
	return(
		<>
		<HeaderBack avatar={1}/>
		<main>
		
		<section className="chat">
			<article>
			<div className="you" >
				<p>hihihii</p>
				<time>time</time>
			</div>
			</article>
			
			<article>
			<div className="you" >
				<p>Now you are in my control hehe</p>
				<time>time</time>
			</div>
			</article>
			
			<article className="me-container">
			<div className="me" >
				<p>hey1</p>
				<time>time</time>
			</div>
			</article>			
			
			<article className="me-container">
			<div className="me" >
				<p>what you doing....</p>
				<time>time</time>
			</div>
			</article>
			
			<article>
			<div className="you" >
				<p>Creating something to implant in your memory and then I can control you ^^</p>
				<time>time</time>
			</div>
			</article>
			
			<article className="me-container">
			<div className="me" >
				<p>What? Stop Joking around</p>
				<time>time</time>
			</div>
			</article>				
			
			<article className="me-container">
			<div className="me" >
				<p>Did you read some science fiction ....</p>
				<time>time</time>
			</div>
			</article>
		</section>
		</main>
		
		<footer className="message-container">
			<MessageBar />
		</footer>
		</>
	);
}